import { createQueryFactory, generateQueryKey } from "../query-factory";
import { queryClient } from "#structure/providers/react-query";
import enterprise from "#resources/api/enterprise-client";

export function useGetZendeskMessagingJwt(): Promise<string> {
	return queryClient.fetchQuery({
		queryKey: generateQueryKey("getZendeskMessagingJwt", undefined),
		queryFn: () => enterprise.getZendeskMessagingJwt({}),
		staleTime: 0,
		retry: false,
	});
}

export const { useApiHook: useListEmployeeZendeskTickets } = createQueryFactory(
	"listEmployeeZendeskTickets",
);

export const { useApiHook: useGetEmployeeZendeskTicketDetails } = createQueryFactory(
	"getEmployeeZendeskTicketDetails",
);
